export const MAX_VISIBLE_PAGES = 5;